export {
    useConsentData,
    useFaqData,
    useGamePageData,
    useGamePageOverviewData,
    useGamePagesListData,
    useGeneralConsentData,
    usePageData,
    usePressArticleData,
    usePressData,
    useVendorListData,
} from '@core/jurisdiction/composables/usePageData'
